import React, { Suspense } from 'react';

// Libs
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import i18n from 'i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from 'Shared/Auth/AuthProvider';
import GlobalStyle from 'Shared/css/GlobalStyles';
import setupi18n from 'Shared/Helpers/i18n';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

// API
import configuredRestLink from 'Shared/api/Issues/IssuesRestLink';

// Components
import {
  iBinderVersion2,
  styleSheetManagerProps
} from '@ibinder/ui-common-styles';
import AuthRoutes from 'Shared/Auth/AuthRoutes';
import { AppPlaceholderLoader } from 'Shared/components/common/applicationPlaceholder';

// Apollo client
const link = configuredRestLink;
const cache = new InMemoryCache();
const client = new ApolloClient({
  cache,
  link
});
// cache.writeQuery(DEFAULT_LOCAL_STATE);

setupi18n(i18n, 'admin');

const AdminProvider = ({ children }) => {
  return (
    <Suspense fallback={<AppPlaceholderLoader />}>
      {/* // TODO: COMMENT */}
      {/* <I18nextProvider i18n={i18n}> */}
      <ApolloProvider client={client}>
        <AuthProvider>
          <StyleSheetManager {...styleSheetManagerProps}>
            <ThemeProvider theme={iBinderVersion2}>
              <GlobalStyle />
              <Router>
                <AuthRoutes />
                {children}
              </Router>
            </ThemeProvider>
          </StyleSheetManager>
        </AuthProvider>
      </ApolloProvider>
      {/* // TODO: COMMENT */}
      {/* </I18nextProvider> */}
    </Suspense>
  );
};

export default AdminProvider;
